import { render, staticRenderFns } from "./PwaSensBannerModuleAlertComponent.vue?vue&type=template&id=25103702&"
import script from "./PwaSensBannerModuleAlertComponent.vue?vue&type=script&lang=js&"
export * from "./PwaSensBannerModuleAlertComponent.vue?vue&type=script&lang=js&"
import style0 from "./PwaSensBannerModuleAlertComponent.vue?vue&type=style&index=0&id=25103702&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports